import colors from "styles/colors"

export interface BaseColorGrades {
  contrast: string
  dark?: string
  light?: string
  main: string
}

export interface ColorGrades {
  contrast: string
  dark: string
  light: string
  main: string
}

export interface BasePalette {
  alert: BaseColorGrades
  disabled: BaseColorGrades
  error: BaseColorGrades
  highlight: BaseColorGrades
  info: BaseColorGrades
  primary: BaseColorGrades
  secondary: BaseColorGrades
  subtitle: BaseColorGrades
  success: BaseColorGrades
  text: BaseColorGrades
  warning: BaseColorGrades
}

export interface Palette {
  alert: ColorGrades
  disabled: ColorGrades
  error: ColorGrades
  highlight: ColorGrades
  info: ColorGrades
  primary: ColorGrades
  secondary: ColorGrades
  subtitle: ColorGrades
  success: ColorGrades
  text: ColorGrades
  warning: ColorGrades
}

export interface BaseTheme {
  font: {
    family: string
  }
  palette: BasePalette
}

export interface UserTheme {
  font?: Partial<BaseTheme["font"]>
  palette?: Partial<BasePalette>
}

export interface ThemeColors {
  gray: ColorGrades
}

export interface Theme extends BaseTheme {
  colors: ThemeColors
  palette: Palette
}

export const baseTheme: BaseTheme = {
  font: {
    family: "Roboto, sans-serif"
  },
  palette: {
    alert: {
      contrast: colors.white,
      main: colors.pomegranate
    },
    disabled: {
      contrast: colors.white,
      main: colors.alto
    },
    error: {
      contrast: colors.white,
      main: colors.pomegranate
    },
    highlight: {
      contrast: colors.white,
      main: colors.boulder
    },
    info: {
      contrast: colors.white,
      main: colors.dustyGray
    },
    primary: {
      contrast: colors.white,
      main: colors.boulder
    },
    secondary: {
      contrast: colors.white,
      main: colors.dustyGray
    },
    subtitle: {
      contrast: colors.white,
      main: colors.dustyGray
    },
    success: {
      contrast: colors.white,
      main: colors.greenYellow
    },
    text: {
      contrast: colors.white,
      main: colors.mineShaft
    },
    warning: {
      contrast: colors.white,
      main: colors.schoolBusYellow
    }
  }
}

export default baseTheme
